export default __webpack_public_path__ + "static/media/CapaCADViewerMobile.d5f97d13.png";